import { configureStore } from "@reduxjs/toolkit";
import { documentsApi } from "../../features/documents/api/documents.api";
import { documentsSettingsApi } from "../../features/documents/api/documentsSettings.api";
import { documentsStructureApi } from "../../features/structures/api/documentsStructure.api";
import { systemTablesApi } from "../../features/tables/api/systemTables.api";
import { customTablesApi } from "../../features/tables/api/customTables.api";
import { accountsStructureApi } from "../../features/structures/api/accountsStructure.api";
import { accountsApi } from "../../features/tickets/public";
import { carsApi } from "../../features/tickets/api/cars.api";
import { itemsApi } from "../../features/tickets/api/items.api";
import { worksApi } from "../../features/tickets/api/works.api";
import { rootReducer } from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefault) =>
    getDefault().concat(
      documentsApi.middleware,
      documentsSettingsApi.middleware,
      documentsStructureApi.middleware,
      systemTablesApi.middleware,
      customTablesApi.middleware,
      accountsStructureApi.middleware,
      accountsApi.middleware,
      carsApi.middleware,
      itemsApi.middleware,
      worksApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
